import utilsApi from '../assets/js/utils';
export default utilsApi.creatApi({
    // 获取明细列表
    getCurrentUserGCoinOperatingRecordList: ["post", "//appapi2.gamersky.com/v5/getCurrentUserGCoinOperatingRecordList"],
    // 获取明细总数
    getCurrentUserAccountInfo: ["post", "//appapi2.gamersky.com/v5/getCurrentUserAccountInfo"],
});